module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_7016.bb852530.png";